
import { useState, useEffect } from "react";
import { DateRange } from "@/hooks/useSearchFilters";

export interface ActiveFiltersState {
  filters: string[];
  distance: number;
  rating: number;
  query: string;
  dateRange?: DateRange;
  availablePortions: number;
  deliveryOnly: boolean;
}

export const useHomePageFilters = () => {
  const [activeFilters, setActiveFilters] = useState<ActiveFiltersState>({
    filters: [],
    distance: 0,
    rating: 0,
    query: '',
    dateRange: undefined,
    availablePortions: 1,
    deliveryOnly: false
  });

  useEffect(() => {
    const handleSearch = (event: CustomEvent) => {
      setActiveFilters(event.detail);
    };

    window.addEventListener('search', handleSearch as EventListener);
    return () => window.removeEventListener('search', handleSearch as EventListener);
  }, []);

  const removeFilter = (filter: string) => {
    setActiveFilters(prev => ({
      ...prev,
      filters: prev.filters.filter(f => f !== filter)
    }));
    window.dispatchEvent(new CustomEvent('filterRemoved', { detail: filter }));
  };

  const clearQuery = () => {
    setActiveFilters(prev => ({ ...prev, query: '' }));
    const searchInput = document.querySelector('input[type="search"]') as HTMLInputElement;
    if (searchInput) {
      searchInput.value = '';
    }
  };

  const clearDeliveryOnly = () => {
    setActiveFilters(prev => ({ ...prev, deliveryOnly: false }));
  };

  const clearDistance = () => {
    setActiveFilters(prev => ({ ...prev, distance: 0 }));
  };

  const clearRating = () => {
    setActiveFilters(prev => ({ ...prev, rating: 0 }));
  };

  const clearPortions = () => {
    setActiveFilters(prev => ({ ...prev, availablePortions: 1 }));
  };

  const clearDateRange = () => {
    setActiveFilters(prev => ({ ...prev, dateRange: undefined }));
  };

  return {
    activeFilters,
    setActiveFilters,
    removeFilter,
    clearQuery,
    clearDeliveryOnly,
    clearDistance,
    clearRating,
    clearPortions,
    clearDateRange,
  };
};
